import styleUtils from '../../styles/styleUtils';
export const positions = {
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    top: 'top',
};
// for right or left drawers
export const drawerWidth = styleUtils.rem(420);
export const drawerGapWidth = styleUtils.rem(56);
/** Gap between top or bottom of screen and Drawer. */
export const drawerGapHeight = 60; // px
export const transitionDelay = 0; // ms
export const zIndexOverlay = 9999;
export const zIndexDrawer = zIndexOverlay + 1;
